import { ClarityLogo } from '@/components/ClarityLogo';
import { LANDING_DESCRIPTION, LANDING_TITLE } from '@/utils/messages';
import { CircularProgress, Typography } from '@mui/material';
import { Landing } from '@verifime/components';
import tokens from '@verifime/design-tokens';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { routeFromSession } from '@/effects/initialiseSessionEffect';

export const INITIALISE_SESSION = '/initialise-session';

export default function InitialiseSession() {
  const router = useRouter();
  const from = router.query['from'] as string | undefined;

  useEffect(() => {
    routeFromSession({ push: router.push, from });
  }, [router.push, from]);

  return (
    <Landing
      title={LANDING_TITLE}
      description={LANDING_DESCRIPTION}
      logo={<ClarityLogo colorMode="onPrimary" />}
    >
      <CircularProgress color="inherit" size={tokens.fontSizeBase} />
      <Typography variant="body1">Please wait</Typography>
    </Landing>
  );
}
